package com.eladfinish.bible.contest.extensions

import com.russhwolf.settings.Settings
import io.github.aakira.napier.Napier

fun Settings.putAllWithLog(
    values: Map<String, Any?>,
    logTag: String = "Settings",
) {
    values.forEach { (key, value) ->
        when (value) {
            null -> {
                remove(key)
                Napier.d("Removed $key (null)", tag = logTag)
            }

            is String -> putString(key, value)
            is Int -> putInt(key, value)
            is Long -> putLong(key, value)
            is Boolean -> putBoolean(key, value)
            is Float -> putFloat(key, value)
            is Double -> putDouble(key, value)

            else -> error(
                "Unsupported Settings value type for key=$key : ${value::class}"
            )
        }
    }

    Napier.d(
        message = buildString {
            append("Saved settings:\n")
            values.forEach { (key, value) ->
                append("• $key = $value\n")
            }
        },
        tag = logTag,
    )
}
